import React from 'react'
import TextField from '@mui/material/TextField'
import isEmail from 'validator/lib/isEmail'

interface IAddField {
  label?: string
  type?: React.HTMLInputTypeAttribute
  value: string
  onChange: (values: string) => void
  error?: boolean
  regex?: RegExp
  required?: boolean
  maxLength?: number
  supressEmptyError?: boolean
}

const AddField: React.FC<IAddField> = ({
  label,
  type,
  value,
  onChange,
  error,
  regex,
  required = false,
  maxLength,
  supressEmptyError,
}) => {
  let isError = error
  if (type === 'email') {
    if (!error && isEmail(value)) {
      isError = false
    } else {
      isError = true
    }
  } else if (regex instanceof RegExp) {
    isError = !!value.match(regex)
  }

  if (supressEmptyError && value === '') {
    isError = false
  }

  return (
    <TextField
      value={value}
      type={type}
      label={label}
      error={isError}
      required={required}
      variant="outlined"
      inputProps={{ maxLength }}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value)
      }}
    />
  )
}

export default AddField
